import './InitiativeScopeTableActionBar.scss';
import { AddToTaskSelector } from './AddToTaskSelector';
import { DeleteInitiativeScopeButton } from './DeleteInitiativeScopeButton';
import { Space } from 'antd';
import { useGlobalSelect } from '@hooks';
import React, { useCallback } from 'react';
export const InitiativeScopeTableActionBar = ({ selectNamespace, initiativeId }) => {
    const { getGlobalSelection, removeSelection } = useGlobalSelect();
    const sonarObjectIds = getGlobalSelection({ namespace: selectNamespace });
    const handleSelectAction = useCallback(() => {
        removeSelection({
            namespace: selectNamespace,
            selections: sonarObjectIds
        });
    }, [removeSelection, selectNamespace, sonarObjectIds]);
    if (!sonarObjectIds.length) {
        return null;
    }
    return (React.createElement(Space, { align: 'end', className: 'compact-scope-action-bar' },
        React.createElement(DeleteInitiativeScopeButton, { initiativeId: initiativeId, onDelete: handleSelectAction, selectedObjectType: undefined, sonarObjectIds: sonarObjectIds }),
        React.createElement(AddToTaskSelector, { initiativeId: initiativeId, onSelect: handleSelectAction, selectAllEnabled: false, sonarObjectIds: sonarObjectIds })));
};
